import { faSave, faSpinner } from '@fortawesome/free-solid-svg-icons'
import { useFormikContext } from 'formik'
import React from 'react'
import { Input } from 'src/components/Forms'
import { Body, Footer } from 'src/components/theme/Models/Modal'
import { Values } from './FormContext'
import YesNo from 'src/components/Forms/YesNo'

interface FormProps {
  toggle: () => void
  isLoading?: boolean
  hasError?: boolean
  disableSave?: boolean
}

const Form: React.FC<FormProps> = (props) => {
  const { hasError, toggle, isLoading, disableSave } = props
  const { handleSubmit } = useFormikContext<Values>()
  return (
    <>
      <Body error={{
        error: 'There was an issue updating the contract onboarding details.',
        show: hasError ?? false
      }}
      >
        <Input type='text' name='onboarding.days' label='Onboarding Days' />
        <YesNo name='onboarding.clearanceReqs' label='Clearance Reqs' />
        <Input type='text' name='onboarding.biProcessTimeframe' label='BI Process Timeframe' />
        <YesNo name='onboarding.gfeProvided' label='GFE Provided' />
        <YesNo name='onboarding.imcEquipment' label='IMC IT Equipment Provided' />
      </Body>
      <Footer
        toggle={toggle}
        onAction={handleSubmit}
        action={{
          text: 'Save',
          icon: isLoading === true ? faSpinner : faSave,
          color: 'primary',
          disabled: disableSave === true || isLoading
        }}
      />
    </>
  )
}

export default Form
